module.exports = __webpack_public_path__ + "static/media/delete.873ce292.svg";